/* slownote v2: reveal motion, mobile carousels, product gallery, zoom, quantity */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = window.matchMedia('(max-width: 749px)');

  var REVEAL = [
    '.sn-hero__sub', '.sn-hero__btn',
    '.sn-promise',
    '.sn-products__grid > .sn-card',
    '.sn-review',
    '.sn-step',
    '.sn-feature__card',
    '.sn-leathers__head .sn-eyebrow', '.sn-leather__text',
    '.sn-about__eyebrow', '.sn-about__body',
    '.sn-faq__head .sn-body', '.sn-faq__list > .sn-acc',
    '.sn-cta__text', '.sn-cta__content > .sn-btn',
    '.sn-contact__text', '.sn-form',
    '.sn-how__head .sn-eyebrow',
    '.sn-gallery', '.sn-product__tp', '.sn-product__db', '.sn-product__acc',
    '.sn-footer__row'
  ].join(',');
  var CURTAIN = '.sn-feature__media, .sn-about__media, .sn-leather__media, .sn-card__media';
  var PARALLAX = '.sn-hero__box, .sn-feature__media, .sn-about__media';
  var SPLIT = '.sn .sn-h, .sn-hero__title, .sn-cta__title, .sn-product__title';

  /* ---------- Reveal: fade-up + line-by-line headings ---------- */
  var io = null;
  if (!reduce && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  }

  var curtainIo = io && new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      (e.target.__snCurtains || []).forEach(function (c) { c.classList.add('is-in'); });
      curtainIo.unobserve(e.target);
    });
  }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });

  function split(h) {
    if (h.dataset.snSplit) return;
    h.dataset.snSplit = '1';
    var parts = h.innerHTML.split(/<br\s*\/?>\s*/i).filter(function (p) { return p.trim() !== ''; });
    h.innerHTML = parts.map(function (p, i) {
      return '<span class="sn-line" style="--i:' + i + '"><span class="sn-line__in">' + p.trim() + '</span></span>';
    }).join('');
    h.classList.add('sn-split');
  }

  function initReveal(root) {
    if (!io) return;
    root.querySelectorAll(SPLIT).forEach(function (h) { split(h); io.observe(h); });
    var groups = new Map();
    root.querySelectorAll(REVEAL).forEach(function (el) {
      if (el.classList.contains('sn-reveal')) return;
      el.classList.add('sn-reveal');
      var p = el.parentElement;
      var n = groups.get(p) || 0;
      el.style.setProperty('--sn-i', Math.min(n, 5));
      groups.set(p, n + 1);
      io.observe(el);
    });
    root.querySelectorAll(CURTAIN).forEach(function (el) {
      if (el.classList.contains('sn-curtain')) return;
      el.classList.add('sn-curtain');
      var row = el.closest('.sn-leathers__row');
      el.style.setProperty('--sn-i', row ? Array.prototype.indexOf.call(row.children, el.parentElement) : 0);
      /* a clipped element can't be observed reliably, so watch its unclipped parent */
      var host = el.parentElement;
      host.__snCurtains = (host.__snCurtains || []).concat(el);
      curtainIo.observe(host);
    });
    root.querySelectorAll('.sn-hero').forEach(function (h) {
      requestAnimationFrame(function () { requestAnimationFrame(function () { h.classList.add('is-in'); }); });
    });
    document.documentElement.classList.add('sn-anim');
  }

  /* ---------- Parallax: full-width photos drift slower than the page ---------- */
  var pxEls = [], pxOn = new Set(), pxRaf = null;
  var pxIo = (!reduce && 'IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) pxOn.add(e.target); else pxOn.delete(e.target); });
    pxTick();
  }, { rootMargin: '10% 0px' }) : null;

  function pxUpdate() {
    pxRaf = null;
    var vh = window.innerHeight;
    pxOn.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
      p = Math.max(-1, Math.min(1, p));
      el.style.setProperty('--sn-py', (p * r.height * 0.025).toFixed(1) + 'px');
    });
  }
  function pxTick() { if (!pxRaf) pxRaf = requestAnimationFrame(pxUpdate); }

  function initParallax(root) {
    if (!pxIo) return;
    root.querySelectorAll(PARALLAX).forEach(function (el) {
      if (el.classList.contains('sn-px') || !el.querySelector(':scope > img')) return;
      el.classList.add('sn-px');
      pxEls.push(el);
      pxIo.observe(el);
    });
  }
  if (pxIo) {
    /* capture: the theme scrolls .page-wrapper on desktop, the window on mobile */
    document.addEventListener('scroll', pxTick, { capture: true, passive: true });
    window.addEventListener('resize', pxTick, { passive: true });
  }

  /* ---------- Mobile carousel: native swipe, eased settle on the nearest card ---------- */
  function easeOutQuart(t) { return 1 - Math.pow(1 - t, 4); }

  function initCarousel(row) {
    if (row.dataset.snCarouselInit) return;
    row.dataset.snCarouselInit = '1';
    var touching = false, timer = null, anim = null;

    function nearest() {
      var pad = parseFloat(getComputedStyle(row).scrollPaddingInlineStart) || 0;
      var best = 0, dist = Infinity;
      Array.prototype.forEach.call(row.children, function (c) {
        var x = c.offsetLeft - row.offsetLeft - pad;
        var d = Math.abs(x - row.scrollLeft);
        if (d < dist) { dist = d; best = x; }
      });
      return Math.max(0, Math.min(best, row.scrollWidth - row.clientWidth));
    }

    function settle() {
      if (!mobile.matches || touching) return;
      var from = row.scrollLeft, to = nearest();
      if (Math.abs(to - from) < 1) return;
      if (reduce) { row.scrollLeft = to; return; }
      var start = performance.now(), dur = 520;
      cancelAnimationFrame(anim);
      (function step(now) {
        var t = Math.min(1, (now - start) / dur);
        row.scrollLeft = from + (to - from) * easeOutQuart(t);
        if (t < 1 && !touching) anim = requestAnimationFrame(step);
      })(start);
    }

    row.addEventListener('touchstart', function () { touching = true; cancelAnimationFrame(anim); clearTimeout(timer); }, { passive: true });
    row.addEventListener('touchend', function () { touching = false; clearTimeout(timer); timer = setTimeout(settle, 140); }, { passive: true });
    row.addEventListener('scroll', function () { if (touching) return; clearTimeout(timer); timer = setTimeout(settle, 140); }, { passive: true });
  }

  /* ---------- Product gallery: thumbs, dots, swipe ---------- */
  function initGallery(g) {
    if (g.dataset.snGalleryInit) return;
    g.dataset.snGalleryInit = '1';
    var track = g.querySelector('[data-track]');
    if (!track) return;
    var thumbs = g.querySelectorAll('.sn-gallery__thumb');
    var dots = g.querySelectorAll('.sn-gallery__dot');
    var prev = g.querySelector('.sn-gallery__arrow--prev');
    var next = g.querySelector('.sn-gallery__arrow--next');
    var cur = 0;

    function mark(i) {
      thumbs.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      cur = i;
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= track.children.length - 1;
    }
    function go(i) {
      track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      mark(i);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.dataset.index, 10) || 0); });
    });
    [prev, next].forEach(function (b) {
      if (!b) return;
      b.addEventListener('click', function () {
        go(Math.max(0, Math.min(track.children.length - 1, cur + parseInt(b.dataset.step, 10))));
      });
    });
    var raf = null;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        if (!track.clientWidth) return;
        mark(Math.round(track.scrollLeft / track.clientWidth));
      });
    }, { passive: true });
  }

  /* ---------- Zoom dialog ---------- */
  function initZoom(section) {
    var dlg = section.querySelector('[data-sn-zoom]');
    if (!dlg || dlg.dataset.snZoomInit) return;
    dlg.dataset.snZoomInit = '1';
    var track = dlg.querySelector('.sn-zoom__track');

    section.querySelectorAll('[data-zoom]').forEach(function (b) {
      b.addEventListener('click', function () {
        var i = parseInt(b.dataset.zoom, 10) || 0;
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
        requestAnimationFrame(function () { if (track) track.scrollLeft = i * track.clientWidth; });
      });
    });
    function close() { if (dlg.open && typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); }
    dlg.querySelectorAll('[data-close]').forEach(function (x) { x.addEventListener('click', close); });
    dlg.addEventListener('click', function (e) {
      if (e.target.tagName !== 'IMG' && !e.target.closest('[data-close]')) close();
    });
    dlg.addEventListener('keydown', function (e) {
      if (!track) return;
      if (e.key === 'ArrowRight') track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
      if (e.key === 'ArrowLeft') track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
    });
  }

  /* ---------- Quantity ---------- */
  function initQty(q) {
    if (q.dataset.snQtyInit) return;
    q.dataset.snQtyInit = '1';
    var input = q.querySelector('.sn-qty__input');
    q.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qty, 10);
        input.value = Math.max(1, v);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ---------- Exclusive accordions: one open per group (fallback for browsers without details[name]) ---------- */
  function initExclusive(root) {
    root.querySelectorAll('details[name]').forEach(function (d) {
      if (d.dataset.snExclInit) return;
      d.dataset.snExclInit = '1';
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        document.querySelectorAll('details[name="' + d.getAttribute('name') + '"]').forEach(function (o) { if (o !== d && o.open) o.open = false; });
      });
    });
  }

  function init(root) {
    root = root || document;
    initReveal(root);
    initParallax(root);
    root.querySelectorAll('[data-sn-carousel]').forEach(initCarousel);
    root.querySelectorAll('[data-sn-gallery]').forEach(initGallery);
    root.querySelectorAll('.sn-product').forEach(initZoom);
    root.querySelectorAll('.sn-qty').forEach(initQty);
    initExclusive(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Theme editor: re-init a section after it re-renders, show everything immediately */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    e.target.querySelectorAll('.sn-reveal, .sn-split, .sn-curtain, .sn-hero').forEach(function (el) { el.classList.add('is-in'); });
  });
})();
